export const initialBranding = {
    orgBgColor: '',
    bgColor:'',
    bgLogo:'',
    buttonColor:'',
    favIcon: '',
    logo: '',
    orgName: '',
    appBgColor: ''
}